function bucketBase(): string {
  const url = import.meta.env.VITE_PUBLIC_BUCKET_URL as string | undefined;
  if (!url) throw new Error('VITE_PUBLIC_BUCKET_URL is not set');
  return url.replace(/\/$/, '');
}

export function emojiUrl(group: string, id: string): string {
  return `${bucketBase()}/static/emojis/${group}/${id}.svg`;
}

export function emojiSpriteUrl(group: string): string {
  return `${bucketBase()}/static/emojis/sprites/${group}.webp`;
}
